import { render, staticRenderFns } from "./picture_header_for_status.vue?vue&type=template&id=17276fc9&scoped=true&"
import script from "./picture_header_for_status.vue?vue&type=script&lang=js&"
export * from "./picture_header_for_status.vue?vue&type=script&lang=js&"
import style0 from "./picture_header_for_status.vue?vue&type=style&index=0&id=17276fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17276fc9",
  null
  
)

export default component.exports